import React from "react";
import CheckIcon from "@material-ui/icons/Check";
import Typography from "@material-ui/core/Typography";

const SelectedToggle = ({ text }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Typography style={{ marginLeft: 2, marginRight: 2, fontSize: '8px', fontWeight: '900' }}>
        {text}
      </Typography>
      <CheckIcon style={{ fontSize: '14px', fontWeight: '900' }} />
    </div>
  );
};

export default SelectedToggle;
